import apiClient from "./apiClient";

export const getWebSlider = () => {
  return apiClient.get("/websiteslider/guest");
};

export const getCategoryList = () => {
  return apiClient.get("/category/guest");
};
export const getCategoryDetails = () => {
  return apiClient.get("/category/guest");
};

export const getHappyCustomer = () => {
  return apiClient.get("/happycustomer");
};

export const submitContactUsFrom = (formData) => {
  return apiClient.post("/enquiry", formData);
};

export const websiteDetails = () => {
  return apiClient.get("/website");
};
